import { getPlayListVideos } from "@/api";
import styles from "./BroadcasterPlaylist.module.scss";
import useSWRImmutable from 'swr/immutable';
import { useRouter } from "next/router";

const PlaylistGrid: React.FC = () => {
  const router = useRouter();
  
  const { data: getVideosData } = useSWRImmutable(
    'playlists',
    async () => {
      const res = await getPlayListVideos();
      // console.log('API responseplaaaaa:', res); // ✅ check shape
      return res.playlists;
    }
  );

  const handleVideoClick = (video: any) => {
    router.push({
      pathname: '/broadcaster/playlistPlayer',
      query: { id: video.id } 
    });
  };

  return (
    <div className={styles.grid}>
      {getVideosData?.map((pl) => (
        <div key={pl.id} className={styles.card} onClick={() => handleVideoClick(pl)}>
          <div className={styles.thumbWrapper}>
            <img src={pl.thumbnailUrl} alt={pl.name} />
            <span className={styles.videoCount}>{pl.videosCount} videos</span>
            <div className={styles.playOverlay}>▶ Play all</div>
          </div>
          <div className={styles.info}>
            <h3>{pl.name}</h3>
            <p className={styles.updated}>{pl.updated}</p>
            <p className={styles.viewAll}>View full playlist</p>
          </div>
        </div>
      ))}
    </div>
  );
}
export default PlaylistGrid;
